<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <section>
        <div class="banner"><img src="../../static/images/AntiFake08/banner.png" /></div>
        <div class="box">
          <div class="code"><input v-model="datas.verify" @keyup.enter="CodeVerify" placeholder="请输入防伪码" /></div>
          <div class="button">
            <a @click="CodeVerify">查询真伪</a>
            <a @click="openScan">扫描二维码</a>
          </div>
          <div class="return">
            <p v-if="!datas.query_count">防伪码错误，请认真核对！</p>
            <p v-else>
              <template v-if="datas.query_count > 1">您所查询的防伪码已被查询过，首次查询时间：{{datas.query_first_time}},查询方式:二维码拍摄,请确认!此次是第{{datas.query_count}}次查询！</template>
              <template v-else>您所查询的防伪码为首次扫描，感谢您的支持！</template>
            </p>
          </div>
          <div class="tip">
            <span>查询方式一</span>
            <p>1.请刮开或揭开商品上防伪标签的涂层或表层，在查询框中输入防伪密码。</p>
            <p>2.点击<i>查询真伪</i>按钮，即可识别产品真伪。</p>
          </div>
          <div class="tip">
            <span>查询方式二</span>
            <p>1.请刮开或揭开商品上防伪标签的涂层或表层，然后直接点击<i>扫描二维码</i>按钮，扫描标签上的二维码，扫描完成，即可识别产品真伪。</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import mixin from '../mixins/mixin.js'
export default {
  name: 'AntiFake08',
  components: {
    'K-Loading': Loading,
  },
  mixins: [mixin],
  data() {
    return {
      datas: null,
      vcode: null,
    }
  },
  created() {
    document.querySelector('body').setAttribute('style', 'background-color:#FFFFFF');
    this.init();
  },
  mounted() {
    this.getWXInfo();
  },
  methods: {
    async init(){
      //判断是演示还是真实码标
      if (this.$route.query.type == "demo") {
        this.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
      } else {
        this.code = this.GetCode();
        await this.GetDatas();  //获取码标信息
        this.CodeVerify();
        console.log(this.datas)
      }
    },
    getSignUrl(){
      var signLink = ''
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        signLink = `https://lj.oid.plus/?${this.code}`;
      } else {
        signLink = location.href
      }
      return signLink;
    },
    getWXInfo: function () {
      $.ajax({
        type: "post",
        url: "https://sale.oid.plus/v1/wechat-public/js-ticket",
        dataType: 'json',
        data: {
          url: this.getSignUrl(),
          syid: "100010034"
        },
        success: function (res) {
          if (res.code == 200) {
            wx.config({
              // debug: true,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: ['scanQRCode']
            });
          }
        }
      });
    },
    openScan: function () {
      let self = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          self.datas.verify = res.resultStr;
          self.CodeVerify();
        }
      });
    },
    CodeVerify() {
      axios.get(this.GetServerUrl(1) + "queryVerify/" + this.code + "/" + this.datas.verify)
        .then( (response) => {
          const json = response.data.meta;
          this.datas.query_count = json.query_count;
          this.datas.query_first_time = json.query_first_time;
        }).catch((error)=> {
          this.datas.query_count = '';
        })
    }
  }
}
</script>
<style scoped>
.banner img{
  width: 100%;
  display: block;
}
.box{
  font-size: 14px;
  padding: 15px 10px;
}
.code input{
  width: 100%;
  box-sizing: border-box;
  height: 34px;
  padding: 6px 12px;
  border: none;
	outline: medium;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}
.button{
  display: flex;
  margin: 15px 0;
  justify-content: space-between;
}
.button a{
  display: table;
  width: 48.5%;
  text-align: center;
  padding: 6px 12px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 4px;
  background-color: #2886C7;
  color: #fff;
  border: 1px solid #2886C7;
}
.return{
  font-weight: 700;
  color: red;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  /* word-wrap: break-word;
  word-break: break-all; */
  text-align: center;
}
.tip{
  margin-top: 20px;
}
.tip span{
  display: block;
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 10px;
}
.tip p{
  padding-left: 15px;
  padding-top: 3px;
  line-height: 21px;
}
.tip i{
  color: red;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/view/AntiFake08.vue